import React, { useEffect, useRef, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchColorsByTextiles} from "../../../../../../reduxLib/colorsLib";
import {uploadProductImages} from "../../../../../../Utilities/uploadHelperProd";
import {fetchPcategories} from "../../../../../../reduxLib/pcategoriesLib";
import {CreateProduct, fetchProductByID, UpdateProduct} from "../../../../../../reduxLib/productLib";
import {createFile} from "../../../../../../reduxLib/filesPhLib";

// ✅ Βάλε τα σωστά imports από τα libs σας
// import uploadProductImages from "....";
// import { createFile } from "...../reduxLib/filesLib";
// import { createProduct } from "...../reduxLib/productLib";
// import { fetchColorsByTextiles } from "...../reduxLib/pcolorsLib";

/**
 * CREATE PRODUCT MODAL with deferred image handling
 *
 * Image Workflow:
 * - All image operations deferred until form submission (create)
 * - Images shown with preview, labeling, and reordering
 * - Images uploaded on submit, never created if deleted before save
 * - Main image: first non-deleted item in filesRelated array
 * - Deleted images: soft-deleted until save (can be restored)
 */
export default function AddProductModal2({ open, setOpen, categories = [], onSubmit = null }) {

    const sizeMap = {
        "5": "Small",
        "4": "Medium",
        "3": "Large",
    };

    const dispatch = useDispatch();

    const fileInputRef = useRef(null);

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileLabels, setFileLabels] = useState({}); // {tempId: label}
    const [deletedFileIds, setDeletedFileIds] = useState(new Set()); // soft delete tracking
    const [editingFileId, setEditingFileId] = useState(null);
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState("");

    //categories fetch
    const [categoryOptions, setCategoryOptions] = useState([]);
    const catstate=useSelector((state)=> state.categoryreducer.state);
    categories= useSelector((state)=> state.categoryreducer.pcategoriesList);


    // textiles -> colors
    const [textilesValue, setTextilesValue] = useState("");
    const [colorsOptions, setColorsOptions] = useState([]); // [{id,name,hex?}]
    const [selectedColorIds, setSelectedColorIds] = useState([]); // unlimited

    // reset όταν ανοίγει/κλείνει
    useEffect(() => {
        if (!open) {
            setSelectedFiles([]);
            setFileLabels({});
            setDeletedFileIds(new Set());
            setEditingFileId(null);
            setSaving(false);
            setErr("");
            setTextilesValue("");
            setColorsOptions([]);
            setSelectedColorIds([]);
        }
    }, [open]);

    useEffect(()=>{

        if(!categories || categories.length === 0) {
            // Fetch the event by ID when the component mounts or when the id changes
            dispatch(fetchPcategories()).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setCategoryOptions(action.payload);
                    console.log("playload ", action.payload);
                    console.log("playload E", categoryOptions);
                }
            });
        }
        else {
            //let f=events.filter((event) => event.ownerid === id);
            // If the event data is already available, set the eventprofile state

            setCategoryOptions(categories);
            console.log("not disp ",categories);
        }
    }, [dispatch,catstate]);

    // load colors when textiles changes
    useEffect(() => {
        let cancelled = false;

        async function loadColors() {
            setErr("");
            if (!textilesValue) {
                setColorsOptions([]);
                setSelectedColorIds([]);
                return;
            }

            try {
                // ✅ thunk που επιστρέφει list colors με βάση textiles
                const action = await dispatch(fetchColorsByTextiles(textilesValue));
                const raw = action?.payload ?? [];

                const normalized = Array.isArray(raw)
                    ? raw.map((c) => ({
                        id: Number(c.pcid),
                        name: c.colorName ?? c.ColorName ?? "",
                        hex: c.hexColor ?? c.HexColor ?? null,
                    }))
                    : [];
                //console.log("NORMALIZED COLORS:", normalized);
                console.log("cansel", cancelled);

                if (cancelled) return;

                setColorsOptions(normalized);

                // κράτα selected που υπάρχουν ακόμα στο νέο textiles
                const allowed = new Set(normalized.map((c) => Number(c.id)));
                setSelectedColorIds((prev) => prev.filter((id) => allowed.has(id)));

            } catch (e) {
                if (!cancelled) setErr(e?.message || "Failed to load colors");
            }
        }

        loadColors();
        return () => {
            cancelled = true;
        };
    }, [textilesValue, dispatch]);

    const toggleColor = (id) => {
        const n = Number(id);
        setSelectedColorIds((prev) =>
            prev.includes(n) ? prev.filter((x) => x !== n) : [...prev, n]
        );
    };

    const onPickFiles = (e) => {
        const files = Array.from(e.target.files || []);
        e.target.value = ""; // allow same file again

        setSelectedFiles((prev) => [...files, ...prev]);

        // Initialize labels for new files
        files.forEach((file) => {
            const id = `file-${Date.now()}-${Math.random()}`;
            setFileLabels((prev) => ({
                ...prev,
                [id]: file.name,
            }));
        });
    };

    const handleDeleteFile = (fileIndex) => {
        setDeletedFileIds((prev) => new Set([...prev, fileIndex]));
    };

    const handleRestoreFile = (fileIndex) => {
        setDeletedFileIds((prev) => {
            const newSet = new Set(prev);
            newSet.delete(fileIndex);
            return newSet;
        });
    };

    const handleSetMainFile = (fileIndex) => {
        const file = selectedFiles[fileIndex];
        setSelectedFiles((prev) => [
            file,
            ...prev.filter((_, idx) => idx !== fileIndex),
        ]);
    };

    const handleMoveFileUp = (fileIndex) => {
        if (fileIndex === 0) return;
        const newFiles = [...selectedFiles];
        [newFiles[fileIndex], newFiles[fileIndex - 1]] = [newFiles[fileIndex - 1], newFiles[fileIndex]];
        setSelectedFiles(newFiles);
    };

    const handleMoveFileDown = (fileIndex) => {
        if (fileIndex >= selectedFiles.length - 1) return;
        const newFiles = [...selectedFiles];
        [newFiles[fileIndex], newFiles[fileIndex + 1]] = [newFiles[fileIndex + 1], newFiles[fileIndex]];
        setSelectedFiles(newFiles);
    };

    const handleUpdateLabel = (fileIndex, newLabel) => {
        setFileLabels((prev) => ({
            ...prev,
            [fileIndex]: newLabel,
        }));
        setEditingFileId(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setSaving(true);

        try {
            const form = new FormData(e.target);

            // Keep active files in final order (main is first)
            const activeFilesOrdered = selectedFiles
                .map((file, idx) => ({
                    file,
                    idx,
                    label: fileLabels[idx] || file.name,
                }))
                .filter((x) => !deletedFileIds.has(x.idx));

            const filesToUpload = activeFilesOrdered.map((x) => x.file);

            // --------- primitives/enums
            const name = (form.get("name") || "").toString().trim();
            const Description = (form.get("Description") || "").toString();
            const details = (form.get("details") || "").toString();

            const categoryRelId = Number(form.get("categoryRelId") || 0);

            const euro = Number(form.get("Price") || 0);
            const Price = Math.round(euro);

            const ConstructionEffortDays = Number(form.get("ConstructionEffortDays") || 0);

            const Dimentions = (form.get("Dimentions") || "").toString();
            const Size = (form.get("Size") || "").toString();

            const productSize = (form.get("productSize") || "").toString() || null;
            const plexis = (form.get("plexis") || "").toString() || null;
            const textiles = textilesValue || null;
            const closingTextiles = (form.get("closingTextiles") || "").toString() || null;

            // --------- 1) upload images -> urls[]
            let uploadedUrls = [];
            if (filesToUpload.length > 0) {
                uploadedUrls = await uploadProductImages(name || "product", filesToUpload);
                if (!Array.isArray(uploadedUrls)) uploadedUrls = [];
            }

            // --------- 2) productCreator payload
            const productCreator = {
                name,
                Description,
                details,
                Price,
                categoryRelId,
                Rating: 0,
                colorsIds: selectedColorIds,
                Dimentions,
                productSize,
                Size,
                plexis,
                textiles,
                closingTextiles,
                ConstructionEffortDays,
                productFilesIds: [],
                isPopular: false,
            };

            console.log("PRODUCT TO CREATE:", productCreator);

            // --------- 3) create product
            const productAction = await dispatch(CreateProduct(productCreator));
            if (productAction.error) {
                throw new Error(productAction.error.message || "Create product failed");
            }

            const productId =
                productAction.payload?.productID ??
                productAction.payload?.id ??
                productAction.payload;

            // --------- 4) create file metadata and link to product
            const createdFilesMetadata = [];
            for (let i = 0; i < uploadedUrls.length; i++) {
                const url = uploadedUrls[i];
                const fileLabel = activeFilesOrdered[i]?.label || `Image ${i + 1}`;
                if (!url) continue;

                const filesCreator = {
                    Name: fileLabel,
                    FileLocation: url,
                    DateCreated: new Date(),
                    fileType: "PRODUCT_IMAGE",
                    productRelId: Number(productId),
                };

                const action = await dispatch(createFile(filesCreator));
                const createdPayload = action?.payload ?? action;
                const newId =
                    createdPayload?.file_ID ??
                    createdPayload?.id ??
                    createdPayload?.fid ??
                    createdPayload;

                createdFilesMetadata.push({
                    file_ID: createdPayload?.file_ID ?? createdPayload?.id ?? createdPayload?.fid ?? null,
                    fileType: createdPayload?.fileType ?? "PRODUCT_IMAGE",
                    productRelId: createdPayload?.productRelId ?? Number(productId),
                    name: createdPayload?.name ?? createdPayload?.Name ?? fileLabel,
                    fileLocation: createdPayload?.fileLocation ?? createdPayload?.FileLocation ?? url,
                    dateCreated: createdPayload?.dateCreated ?? createdPayload?.DateCreated ?? new Date().toISOString(),
                });

                if (newId != null) productCreator.productFilesIds.push(Number(newId));
            }

            // --------- 5) update product so filesRelated includes created file metadata
            if (createdFilesMetadata.length > 0) {
                const fetchedProductAction = await dispatch(fetchProductByID(Number(productId)));
                const fetchedProduct = fetchedProductAction?.payload ?? {};

                const updatePayload = {
                    ...fetchedProduct,
                    productID: fetchedProduct?.productID ?? Number(productId),
                    filesRelated: createdFilesMetadata,
                    productFilesIds: productCreator.productFilesIds,
                };

                await dispatch(
                    UpdateProduct({
                        pid: Number(productId),
                        productData: updatePayload,
                    })
                );
            }

            // --------- 6) notify parent to refresh product list
            if (onSubmit) {
                onSubmit(productId);
            }

            setOpen(false);
        } catch (ex) {
            setErr(ex?.message || "Create product failed");
        } finally {
            setSaving(false);
        }
    };
    const [SizeValue, setSizeValue] = useState("");

    const handleProductSizeChange = (e) => {
        const v = (e.target.value || "").toString();
        setSizeValue(sizeMap[v] ?? "");
    };

    if (!open) return null;

    return (
        <div
            className="modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => !saving && setOpen(false)}
        >
            <div
                className="bg-white rounded-lg p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-serif font-bold text-custom-green">
                        Add New Product
                    </h2>
                    <button
                        onClick={() => !saving && setOpen(false)}
                        className="text-gray-400 hover:text-gray-600"
                        type="button"
                    >
                        <i className="fa-solid fa-times text-xl" />
                    </button>
                </div>

                {err && (
                    <div className="mb-4 p-3 rounded bg-red-50 text-red-700 text-sm border border-red-200">
                        {err}
                    </div>
                )}

                <form className="space-y-6" onSubmit={handleSubmit}>
                    {/* name + category */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Product Name *
                            </label>
                            <input
                                type="text"
                                name="name"
                                required
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Category *
                            </label>
                            <select
                                name="categoryRelId"
                                required
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            >
                                <option value="">Select Category</option>
                                {categories.length > 0 ? (
                                    categories.map((c) => (
                                        <option key={c.categoryID ?? c.pid} value={c.categoryID ?? c.pid}>
                                            {c.name}
                                        </option>
                                    ))
                                ) : (
                                    <>
                                        <option value="-1">not found</option>
                                    </>
                                )}
                            </select>
                        </div>
                    </div>

                    {/* description */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Description *
                        </label>
                        <textarea
                            name="Description"
                            rows={3}
                            required
                            disabled={saving}
                            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                        />
                    </div>

                    {/* details */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Details
                        </label>
                        <textarea
                            name="details"
                            rows={4}
                            disabled={saving}
                            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                        />
                    </div>

                    {/* price + construction days */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Price (€) *
                            </label>
                            <input
                                type="number"
                                name="Price"
                                step="0.01"
                                required
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                            <p className="text-xs text-gray-500 mt-1">
                                Στέλνεται σε cents (long).
                            </p>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Construction Days
                            </label>
                            <input
                                type="number"
                                name="ConstructionEffortDays"
                                min="1"
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                        </div>
                    </div>

                    {/* dimensions + size */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Dimensions
                            </label>
                            <input
                                type="text"
                                name="Dimentions"
                                placeholder="e.g., 30x40x25 cm"
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                        </div>
                        {/* product size */}
                        {/* product size */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Product Size
                            </label>
                            <select
                                name="productSize"
                                disabled={saving}
                                onChange={handleProductSizeChange}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            >
                                <option value="">Select</option>
                                <option value="5">Small</option>
                                <option value="4">Medium</option>
                                <option value="3">Large</option>
                            </select>
                        </div>

                        {/* size (locked, derived from productSize) */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Size
                            </label>
                            <input
                                type="text"
                                value={SizeValue}
                                readOnly
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-gray-600"
                                placeholder="Auto from Product Size"
                            />

                            {/* IMPORTANT: αυτό είναι που διαβάζεις στο submit: form.get("Size") */}
                            <input type="hidden" name="Size" value={SizeValue} />
                        </div>
                    </div>

                    {/* special props */}
                    <div className="border-t pt-6">
                        <h3 className="text-lg font-medium text-gray-900 mb-4">
                            Special Properties
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* textiles (drives colors) */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Textiles
                                </label>
                                <select
                                    name="textiles"
                                    value={textilesValue}
                                    onChange={(e) => setTextilesValue(e.target.value)}
                                    disabled={saving}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="">None</option>
                                    <option value="bambakero">bambakero</option>
                                    <option value="bambakeroLourex">bambakeroLourex</option>
                                    <option value="forte">forte</option>
                                </select>
                                <p className="text-xs text-gray-500 mt-1">
                                    Με βάση αυτό εμφανίζονται τα διαθέσιμα colors.
                                </p>
                            </div>

                            {/* colors (unlimited multi) */}
                            <div>
                                <div className="flex items-center justify-between mb-2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Available Colors
                                    </label>
                                    <span className="text-xs text-gray-500">
                {selectedColorIds.length} selected
              </span>
                                </div>
                                {
                                    !textilesValue ? (
                                        <div className="text-sm text-gray-500 border rounded-lg p-4">
                                            Διάλεξε πρώτα <b>Textiles</b> για να εμφανιστούν χρώματα.
                                        </div>
                                    ) : (
                                        <div className="grid grid-cols-4 md:grid-cols-6 gap-3 max-h-48 overflow-y-auto p-2 border rounded-lg">
                                            {
                                                colorsOptions.map(
                                                    (c) => {
                                                        const id = Number(c.id);
                                                        const checked = selectedColorIds.includes(id);

                                                        return (
                                                            <button
                                                                key={id}
                                                                type="button"
                                                                onClick={() => toggleColor(id)}
                                                                disabled={saving}
                                                                className="flex flex-col items-center space-y-1 cursor-pointer group"
                                                                title={c.name}
                                                            >
                                                                <div
                                                                    className={`w-12 h-12 rounded-lg border-2 transition-all group-hover:scale-105 ${
                                                                        checked
                                                                            ? "border-custom-green ring-2 ring-custom-green"
                                                                            : "border-gray-300"
                                                                    }`}
                                                                    style={c.hex ? { backgroundColor: c.hex } : undefined}
                                                                />
                                                                <span className="text-xs text-center">{c.name}</span>
                                                            </button>
                                                        );
                                                    }
                                                )
                                            }
                                        </div>
                                    )}
                            </div>

                            {/* plexis */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Plexis
                                </label>
                                <select
                                    name="plexis"
                                    disabled={saving}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="">None</option>
                                    <option value="basic">basic</option>
                                    <option value="kagelaki">kagelaki</option>
                                    <option value="grammh">grammh</option>
                                    <option value="vafla">vafla</option>
                                </select>
                            </div>

                            {/* closing textiles */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Closing Textiles
                                </label>
                                <select
                                    name="closingTextiles"
                                    disabled={saving}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="None">Δεν έχει</option>
                                    <option value="SIMPLE">Απλό</option>
                                    <option value="CABOURAS">Καβούρας</option>
                                    <option value="AXTIDA">Αχτίδα</option>
                                    <option value="TSOUREKI">Τσουρέκι</option>
                                </select>
                            </div>

                        </div>
                    </div>



                    {/* images */}
                    <div>
                        <div className="flex items-center justify-between mb-2">
                            <label className="block text-sm font-medium text-gray-700">
                                Product Images
                            </label>
                            <span className="text-xs text-gray-500">
                                {selectedFiles.filter((_, idx) => !deletedFileIds.has(idx)).length} images
                            </span>
                        </div>

                        {/* Image grid */}
                        {selectedFiles.length > 0 && (
                            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3 mb-4">
                                {selectedFiles.map((file, idx) => {
                                    const isDeleted = deletedFileIds.has(idx);
                                    const isMain = idx === 0 && !isDeleted;
                                    const isEditing = editingFileId === idx;
                                    const label = fileLabels[idx] || file.name;

                                    return (
                                        <div
                                            key={`${file.name}-${idx}`}
                                            className={`border rounded-lg overflow-hidden transition-opacity ${
                                                isDeleted ? "opacity-40" : "opacity-100"
                                            }`}
                                        >
                                            <div className="aspect-square bg-gray-50 relative flex items-center justify-center">
                                                <div className="text-gray-400 text-3xl">
                                                    <i className="fa-solid fa-image"></i>
                                                </div>

                                                {isMain && (
                                                    <div className="absolute top-1 right-1 bg-custom-green text-white text-[10px] px-2 py-0.5 rounded font-semibold">
                                                        MAIN
                                                    </div>
                                                )}

                                                {isDeleted && (
                                                    <div className="absolute inset-0 bg-red-500/20 flex items-center justify-center">
                                                        <span className="text-xs font-semibold text-red-700">DELETED</span>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Label editor */}
                                            <div className="p-2 bg-white">
                                                {isEditing ? (
                                                    <div className="flex gap-1 mb-2">
                                                        <input
                                                            type="text"
                                                            value={label}
                                                            onChange={(e) =>
                                                                setFileLabels((prev) => ({
                                                                    ...prev,
                                                                    [idx]: e.target.value,
                                                                }))
                                                            }
                                                            autoFocus
                                                            className="flex-1 text-xs px-2 py-1 border rounded"
                                                            placeholder="Image label"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                handleUpdateLabel(idx, fileLabels[idx] || label)
                                                            }
                                                            className="px-2 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600"
                                                        >
                                                            ✓
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="text-[11px] text-gray-600 truncate mb-2" title={label}>
                                                        {label}
                                                    </div>
                                                )}

                                                {/* Actions */}
                                                <div className="flex flex-col gap-1">
                                                    {!isDeleted ? (
                                                        <>
                                                            <button
                                                                type="button"
                                                                onClick={() => setEditingFileId(idx)}
                                                                className="w-full px-1 py-0.5 border rounded hover:bg-blue-50 text-xs"
                                                                disabled={saving}
                                                            >
                                                                Edit Label
                                                            </button>

                                                            {!isMain && (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleSetMainFile(idx)}
                                                                    className="w-full px-1 py-0.5 border rounded hover:bg-green-50 text-xs"
                                                                    disabled={saving}
                                                                >
                                                                    Set Main
                                                                </button>
                                                            )}

                                                            <div className="flex gap-1">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleMoveFileUp(idx)}
                                                                    disabled={idx === 0 || saving}
                                                                    className="flex-1 px-1 py-0.5 border rounded hover:bg-gray-100 disabled:opacity-30 text-xs"
                                                                >
                                                                    ↑
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleMoveFileDown(idx)}
                                                                    disabled={idx === selectedFiles.length - 1 || saving}
                                                                    className="flex-1 px-1 py-0.5 border rounded hover:bg-gray-100 disabled:opacity-30 text-xs"
                                                                >
                                                                    ↓
                                                                </button>
                                                            </div>

                                                            <button
                                                                type="button"
                                                                onClick={() => handleDeleteFile(idx)}
                                                                className="w-full px-1 py-0.5 border rounded hover:bg-red-50 text-red-600 text-xs"
                                                                disabled={saving}
                                                            >
                                                                Delete
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleRestoreFile(idx)}
                                                            className="w-full px-1 py-0.5 border rounded hover:bg-yellow-50 text-yellow-600 text-xs"
                                                            disabled={saving}
                                                        >
                                                            Restore
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* Upload button */}
                        <button
                            type="button"
                            className="w-full border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 disabled:opacity-60 hover:border-custom-green transition"
                            onClick={() => fileInputRef.current?.click()}
                            disabled={saving}
                        >
                            <i className="fa-solid fa-cloud-upload-alt text-3xl text-gray-400 mb-2" />
                            <p className="text-gray-600">
                                {saving ? "Saving..." : "Click to upload images"}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                                Upload multiple images, they will be uploaded when you create the product
                            </p>
                        </button>

                        <input
                            ref={fileInputRef}
                            type="file"
                            multiple
                            accept="image/*"
                            className="hidden"
                            onChange={onPickFiles}
                            disabled={saving}
                        />
                    </div>

                    <div className="flex justify-end space-x-4 pt-4">
                        <button
                            type="button"
                            onClick={() => !saving && setOpen(false)}
                            className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-60"
                            disabled={saving}
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            className="px-6 py-2 bg-custom-green text-white rounded-lg hover:bg-opacity-90 disabled:opacity-60"
                            disabled={saving}
                        >
                            {saving ? "Creating..." : "Add Product"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
